import { REDUCE_PAYMENT_TRANSFER_RESULT_RECORDS } from '../../constants/actions/payment';

export function reducePaymentTransferResultRecords(payload) {
    return {
        type: REDUCE_PAYMENT_TRANSFER_RESULT_RECORDS,
        payload,
    };
}
